import {connect, IConnectProps} from 'globx-react';
import * as React               from 'react';

import StoreName               from '../../../../State/Shared/Constants/StoreName';
import IPlayerStores           from '../../../../State/Shared/Interfaces/IPlayerStores';
import Frame                   from '../../../../State/Stores/Frame/Frame';
import getRandomItemFromObject from '../../../Shared/Util/getRandomItemFromObject';

import tags                  from './Constants/tags';
import createWatermarkStyles from './Util/createWatermarkStyles';

@connect(StoreName.FRAME)
class Watermark extends React.Component<IConnectProps<Frame, IPlayerStores>> {
    public shouldComponentUpdate(nextProps: IConnectProps<Frame, IPlayerStores>): boolean {
        return this.props.value.watermarkStatus !== nextProps.value.watermarkStatus;
    }

    public render(): JSX.Element {
        const {value} = this.props;
        const {showWatermark, content} = this.props.stores.config.value.watermark;
        const RandomTag = getRandomItemFromObject(tags);

        if (!showWatermark || !value.isWatermarkShown) return null;

        return (
            <RandomTag style={createWatermarkStyles(value.watermarkStatus, value.areControlsActive)}>
                {content}
            </RandomTag>
        );
    }
}

export default Watermark;